console.log("ENV", process.env.VUE_APP_API_PATH);
window.base_path = process.env.VUE_APP_API_PATH;
window.scanaction = "/api/v1/scanaction.php";
window.ws = "/api/v1/response/";
window.filesDCM = "/archivos/dcm/";
window.filesORDEN = "/archivos/orden/";
window.filesOTRODCM = "/archivos/otrodcm/";

window.lang = {};
window.lang.es = {
  label_solicitante: "Seleccione Odontólogo",
  label_informante: "Seleccione Radiólogo",
};

window.debugmode = false;

// localStorage.clear();

if (typeof localStorage.isLogged === "undefined") {
  localStorage.isLogged = false;
}

// core
import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import VueRouter from "vue-router";
// import axios from 'axios'
import Viewer from "v-viewer";
import MultiFiltersPlugin from "./plugins/MultiFilters";
// import ValidateRutPlugin from './plugins/ValidateRut'
import es from "vuetify/es5/locale/es"; // Translation provided by Vuetify (javascript)
// import VueZoomer from 'vue-zoomer'
// import { VueContext } from 'vue-context'

// styles
import "vuetify/dist/vuetify.min.css";
import "viewerjs/dist/viewer.css";
// import 'vue-zoomer/dist/vue-zoomer.css'

// Importar Componentes
import Login from "./components/Login.vue";
// import Home from './components/Home.vue'
import Exams from "./components/Exams.vue";
// import Exam from './components/Exam.vue'
import ExamEdit from "./components/ExamEdit.vue";
import ExamReport from "./components/ExamReport.vue";
import Users from "./components/Users.vue";
import Patients from "./components/Patients.vue";
import Templates from "./components/Templates.vue";
import Images from "./components/Images.vue";
import Find from "./components/Find.vue";
import Institutions from "./components/Institutions.vue";
import Modalities from "./components/Modalities.vue";
import Provisions from "./components/Provisions.vue";
import Applicants from "./components/Applicants.vue";
import NewImages from "./components/NewImages.vue";

//Partes
import Editor from "./components/parts/Editor.vue";

// Vue.use(Vuetify)
Vue.use(MultiFiltersPlugin);
Vue.use(Viewer);
// Vue.use(VueZoomer)

Vue.config.productionTip = false;

// Helpers
import colors from "vuetify/es5/util/colors";
/**
  #18afd3 CYAN
  #f5f5f5 LIGHT GRAY
  #f57e57 ORANGE
  #4c6575 GRAY
  #ab91c0 PURPLE
  #5a8ec7 BLUE
  #395261 DARK GRAY
*/

Vue.use(Vuetify, {
  lang: {
    locales: { es },
    current: "es",
  },
  theme: {
    primary: "#4c6575", // GRAY
    secondary: "#395261", // DARK GRAY
    tertiary: "#EEEEEE", //'#f5f5f5', // LIGHT GRAY
    accent: "#18afd3", // CYAN
    error: colors.deepOrange, // '#ff5722', // deep-orange
    warning: "#f57e57", // ORANGE
    info: "#ab91c0", // PURPLE
    success: "#5a8ec7", // BLUE
    loaddcm: "#1A237E", // indigo darken-4
  },
});

//console.log('colors', colors)

Vue.use(VueRouter);

// Rutas
const routes = [
  { path: "*", name: "NotFound", redirect: { name: "Home" } },
  { path: "/", name: "Home", redirect: { name: "Exams" } },
  { path: "/ingreso/", name: "Login", component: Login },
  { path: "/examenes/", name: "Exams", component: Exams },
  { path: "/examen/:id_examen/editar", name: "ExamEdit", component: ExamEdit },
  {
    path: "/examen/:id_examen/informar",
    name: "ExamReport",
    component: ExamReport,
  },
  { path: "/usuarios/", name: "Users", component: Users },
  { path: "/pacientes/", name: "Patients", component: Patients },
  { path: "/plantillas/", name: "Templates", component: Templates },
  { path: "/instituciones/", name: "Institutions", component: Institutions },
  { path: "/modalidades/", name: "Modalities", component: Modalities },
  { path: "/prestaciones/", name: "Provisions", component: Provisions },
  { path: "/solicitantes/", name: "Applicants", component: Applicants },
  { path: "/imagenes/:id_examen/:type", name: "Images", component: Images },
  { path: "/consulta/", name: "Find", component: Find },
  {
    path: "/newimagenes/:id_examen/:type",
    name: "NewImages",
    component: NewImages,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

//Exportar bus de comunicación entre componentes
export const bus = new Vue();

// Inicialización de Componentes
Vue.component("v-editor", Editor);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
